import validate from "/home/runner/work/1/s/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45locale_45global from "/home/runner/work/1/s/middleware/01.locale.global.ts";
import _02_45region_45global from "/home/runner/work/1/s/middleware/02.region.global.ts";
import _03_45redirect_45global from "/home/runner/work/1/s/middleware/03.redirect.global.ts";
import _04_45path_45global from "/home/runner/work/1/s/middleware/04.path.global.ts";
import _05_45route_45info_45global from "/home/runner/work/1/s/middleware/05.routeInfo.global.ts";
import manifest_45route_45rule from "/home/runner/work/1/s/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _01_45locale_45global,
  _02_45region_45global,
  _03_45redirect_45global,
  _04_45path_45global,
  _05_45route_45info_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "category-redirect": () => import("/home/runner/work/1/s/middleware/category-redirect.ts"),
  "pricing-plan-redirect": () => import("/home/runner/work/1/s/middleware/pricing-plan-redirect.ts"),
  "product-redirect": () => import("/home/runner/work/1/s/middleware/product-redirect.ts")
}